
function Top() {
    return (
      <>
        <a id="Link" href='https://www.linkedin.com/in/abdullahtariq78/' target='_Blank' rel="noopener noreferrer"> LinkedIn </a>
        <a id="Git" href='https://github.com/Abdullahprogramme' target='_Blank' rel="noopener noreferrer"> GitHub </a>
        <h1 id="Head"> CheckBMI </h1>
      </>
    )
}

export {Top};